import {Attributes, AttributesRow, Avatar, Card} from 'platform/components';
import {Heading, HStack, VStack} from 'platform/foundation';

import {GetArticleResponse} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

interface ForecastCardProps {
  stockManagement: GetArticleResponse['stockManagement'];
  handlingUnitLabel: string;
}

export function ForecastCard(props: ForecastCardProps) {
  const decreasingForecastRows: AttributesRow[] = [
    {
      label: i18n.t('entity.warehouse.labels.reservations'),
      value: `${props.stockManagement.reservationQuantity ?? 0} ${props.handlingUnitLabel}`,
    },
    {
      label: i18n.t('entity.warehouse.labels.orderRequests'),
      value: `${props.stockManagement.orderRequestsQuantity ?? 0} ${props.handlingUnitLabel}`,
    },
    {
      label: i18n.t('entity.warehouse.labels.returnToSupplier(pending)'),
      value: `${props.stockManagement.returnToSupplierQuantity ?? 0} ${props.handlingUnitLabel}`,
    },
  ];

  const increasingForecastRows: AttributesRow[] = [
    {
      label: i18n.t('entity.warehouse.labels.returnToWarehouse(pending)'),
      value: `${props.stockManagement.returnToWarehouseQuantity ?? 0} ${props.handlingUnitLabel}`,
    },
    {
      label: i18n.t('entity.warehouse.labels.supplierOrders(pending)'),
      value: `${props.stockManagement.orderPendingQuantity ?? 0} ${props.handlingUnitLabel}`,
    },
    {
      label: i18n.t('entity.warehouse.labels.orderedAtSupplier'),
      value: `${props.stockManagement.orderedQuantity ?? 0} ${props.handlingUnitLabel}`,
    },
    {
      label: i18n.t('entity.warehouse.labels.receiveNote(pending)'),
      value: `${props.stockManagement.receiveQuantity ?? 0} ${props.handlingUnitLabel}`,
    },
  ];

  return (
    <Card hasSeparator isExpandable title={i18n.t('entity.warehouse.labels.forecast')}>
      <VStack spacing={4}>
        <Card variant="inlineGrey">
          <VStack spacing={1}>
            <HStack spacing={2} align="center">
              <Avatar
                icon="navigation/arrow_downward"
                variant="square"
                size="xSmall"
                iconColor="palettes.red.80.100"
                color="palettes.red.20.100"
              />
              <Heading size={5} color="danger">
                {i18n.t('entity.warehouse.labels.decreasingForecast')}
              </Heading>
            </HStack>
            <Attributes rows={decreasingForecastRows} size="half" />
          </VStack>
        </Card>
        <Card variant="inlineGrey">
          <VStack spacing={1}>
            <HStack spacing={2} align="center">
              <Avatar
                icon="navigation/arrow_upward"
                variant="square"
                size="xSmall"
                iconColor="palettes.green.80.100"
                color="palettes.green.20.100"
              />
              <Heading size={5} color="success">
                {i18n.t('entity.warehouse.labels.increasingForecast')}
              </Heading>
            </HStack>
            <Attributes rows={increasingForecastRows} size="half" />
          </VStack>
        </Card>
      </VStack>
    </Card>
  );
}
